<h3 mat-dialog-title class="title">{{ "coupons.rules.grid.edit.jobs.addTitle" | translate }}</h3>

<mat-dialog-content>
    <div class="add-job" [formGroup]="jobToAdd">
            <mat-form-field class="time-zone">
                <mat-label>{{ 'coupons.rules.grid.edit.jobs.add.timeZone' | translate }}</mat-label>
                <input #timeZoneFilterInput
                       matInput type="text"
                       required
                       *ngIf="timeZoneSelect.panelOpen"
                        [value]="timeZoneFilterInput.value"
                        [placeholder]="inputFocused ? ('store.storeInfo.timeZone' | translate) : null"
                        (input)="filteredTimeZones = filterItems(timeZoneFilterInput.value, timeZones, 'timeZoneCode')"
                        (focus)="inputFocused = true"
                        (blur)="inputFocused = false">
                <!-- Hide mat-select when input is focused -->
                <mat-select matInput
                            #timeZoneSelect
                            data-qa-label="TimeZoneSelect"
                            panelClass="custom-autocomplete-select country-select"
                            [ngClass]="{ 'hidden-select': timeZoneSelect.panelOpen }"
                            disableOptionCentering
                            class="country-select"
                            formControlName="timeZone"
                            [placeholder]="!inputFocused ? ('store.storeInfo.timeZone' | translate) : null">
                    <mat-option *ngFor="let timeZone of filteredTimeZones"
                                [value]="timeZone.timeZoneCode"
                                class="option">
                        {{ timeZone.timeZoneName }}
                    </mat-option>
                </mat-select>
                <mat-error>
                    {{ 'form.error.required' | translate }}
                </mat-error>
            </mat-form-field>

            <mat-form-field>
            <mat-label>{{ 'coupons.rules.grid.edit.jobs.add.date.label' | translate }}</mat-label>
            <input matInput
                   [min]="minDate"
                   [ngxMatDatetimePicker]="jobStartDatePicker"
                   required
                   formControlName="date">
            <mat-datepicker-toggle matSuffix [for]="$any(jobStartDatePicker)">
            </mat-datepicker-toggle>
            <ngx-mat-datetime-picker #jobStartDatePicker
                                        [showSpinners]="true"
                                        [showSeconds]="true"
                                        [stepHour]="1"
                                        [stepMinute]="1"
                                        [stepSecond]="5"
                                        [color]="color"
                                        [enableMeridian]="true">
                    <ngx-mat-datepicker-actions>
                        <button color="primary"
                                ngxMatDatepickerApply
                                mat-icon-button
                                [attr.aria-label]="'form.button.select' | translate ">
                            <i class="tce-icon-checkmark"></i>
                        </button>
                    </ngx-mat-datepicker-actions>
            </ngx-mat-datetime-picker>
            <mat-error *ngIf="jobToAdd.get('date').errors?.required">
                {{ 'form.error.required' | translate }}
            </mat-error>
            <mat-error *ngIf="jobToAdd.get('date').errors?.invalid">
                {{ 'coupons.rules.grid.edit.jobs.add.date.error' | translate }}
            </mat-error>
            </mat-form-field>

            <mat-form-field class="segments">
            <mat-label>{{ 'coupons.rules.grid.loadingSegments' | translate }}</mat-label>
            <mat-select matInput
                        required
                        #segmentSelectInput
                        panelClass="custom-autocomplete-select one-time-select"
                        disableOptionCentering
                        class="segment-select"
                        [ngClass]="{ 'hidden-select': segmentSelectInput.panelOpen }"
                        multiple
                        (opened)="filterSegments.focus()"
                        data-qa-label="SegmentsSelect"
                        formControlName="segments"
                        [(value)]="selectedSegments"
                        placeholder="{{ 'coupons.rules.grid.fields.segments' | translate }}">
                <mat-option
                [hidden]="!segmentSearch"
                disabled
                value="">
                <txp-loading [type]="loadingType.INLINE" [color]="loadingColor.COLOR"></txp-loading>
                {{ 'coupons.rules.grid.loadingSegments' | translate }}
                </mat-option>
                <mat-option *ngFor="let segment of segmentsList.filteredData"
                            [value]="segment.id"
                            class="option">
                <div class="option-name">{{ segment.segmentName }}</div>
                </mat-option>
            </mat-select>
            <input
                #filterSegments
                type="text"
                matInput
                [hidden]="!segmentSelectInput.panelOpen"
                formControlName="filterSegments"
                placeholder="{{ 'coupons.rules.grid.filterSegments' | translate }}">
            <mat-error>
                {{ 'form.error.required' | translate }}
            </mat-error>
            </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions>

    <txp-button [style]="buttonStyle.SECONDARY"
                class="cancel-add-job-btn"
                data-qa-label="CancelAddJobBtn"
                (click)="onCancel();
                $event.preventDefault()">
        {{ 'coupons.rules.grid.edit.jobs.cancelAddBtn' | translate }}
    </txp-button>

    <txp-button class="save-job-btn"
                [disabled]="isSaving || jobToAdd.invalid || jobToAdd.pristine"
                data-qa-label="SaveJobBtn"
                [style]="buttonStyle.SECONDARY"
                [attr.title]="'form.button.save' | translate"
                (click)="onSaveJob()">
        {{ 'form.button.save' | translate }}
    </txp-button>

</mat-dialog-actions>


